const PencilIcon = ({
  width = 8,
  height = 8,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M4.23778 1.55469L0.409269 5.38848C0.268193 5.53001 0.179034 5.71514 0.156267 5.91381L0.00372176 7.25508C-0.006222 7.3494 0.00381451 7.44476 0.0331759 7.53493C0.0625373 7.6251 0.110563 7.70806 0.174117 7.77838C0.237671 7.8487 0.315323 7.90481 0.402003 7.94303C0.488683 7.98126 0.58244 8.00075 0.677153 8.00022H0.755286L2.09471 7.84747C2.29231 7.82458 2.47678 7.7368 2.61931 7.59784L6.44782 3.76033L4.23778 1.55469Z"
      fill="#3FA9DB"
    />
    <path
      d="M7.74276 1.23009L6.77168 0.257674C6.69044 0.176003 6.5939 0.111199 6.48759 0.0669806C6.38129 0.0227622 6.26731 0 6.15219 0C6.03708 0 5.9231 0.0227622 5.8168 0.0669806C5.71049 0.111199 5.61395 0.176003 5.53271 0.257674L4.63232 1.1593L6.84237 3.3724L7.74276 2.47077C7.82432 2.38942 7.88903 2.29275 7.93319 2.18629C7.97735 2.07984 8.00008 1.9657 8.00008 1.85043C8.00008 1.73516 7.97735 1.62102 7.93319 1.51457C7.88903 1.40811 7.82432 1.31144 7.74276 1.23009Z"
      fill="#3FA9DB"
    />
  </svg>
);

export default PencilIcon;
